import { IconButton, ListItemIcon, Pagination, TextField } from "@mui/material";
import Grid from "@mui/material/Grid2";
import Switch from "@mui/material/Switch";
import React, { useEffect, useState } from "react";
import { CATEGORY_URL } from "../../Constants/Constants";
import AxiosInstance from "../../services/AxiosInstance";
import CategoryDialog from "./CategoryDialog";
import Zoom from "@mui/material/Zoom";

//Table view
import { createTheme, ThemeProvider, useTheme } from "@mui/material";
import Box from "@mui/material/Box";
import Paper from "@mui/material/Paper";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell, { tableCellClasses } from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import TableHead from "@mui/material/TableHead";
import TablePagination from "@mui/material/TablePagination";
import TableRow from "@mui/material/TableRow";
import Tooltip from "@mui/material/Tooltip";
import { styled } from "@mui/material/styles";
import Container from "react-bootstrap/Container";
import AppTableView from "../AppTableView";
import { SOLUTIONS_CATEGORY_COLUMNS } from "../ticket/grid/GridDataConstants";
import GridViewIcon from "@mui/icons-material/GridView";
import ListIcon from "@mui/icons-material/List";
import { isEmpty } from "../../Constants/RolesConstants";

const Category = ({ componentPermissions }) => {
  const globaltheme = useTheme();
  const theme = createTheme({
    ...globaltheme,
    components: {
      MuiSelect: {},
    },
  });
  const [categories, setCategories] = useState([]);
  const [filteredCategories, setFilteredCategories] = useState([]);
  const [page, setPage] = useState(1);
  const [searchTerm, setSearchTerm] = useState("");
  const [viewListMode, setViewListMode] = useState(true);

  const [gridPage, setGridPage] = useState(0);
  // Simulate fetching categories
  useEffect(() => {
    getCategories();
  }, []);

  const getCategories = () => {
    // TODO: server side pagination isn't implemented in server yet, so this will be currently client side pagination
    AxiosInstance.get(CATEGORY_URL).then((response) => {
      setCategories(response.data.data);
      setFilteredCategories(response.data.data);
    });
  };
  // Handle search term change
  const handleSearch = (event) => {
    const term = event.target.value.toLowerCase();
    setSearchTerm(term);
    setFilteredCategories(
      categories.filter((category) =>
        category.name.toLowerCase().includes(term)
      )
    );
  };

  // Handle pagination change
  const handlePageChange = (event, value) => {
    setPage(value);
  };

  const handleViewModeChange = (event) => {
    if (viewListMode === true) {
      setViewListMode(false);
    } else {
      setViewListMode(true);
      setGridPage(0);
      setPage(1);
    }
    //getCategories();
  };

  // Pagination variables
  const categoriesPerPage = 3;
  const totalPages = Math.ceil(filteredCategories.length / categoriesPerPage);
  const currentCategories = filteredCategories.slice(
    (page - 1) * categoriesPerPage,
    page * categoriesPerPage
  );

  const iconButtonStyle = {
    transition: "transform 0.2s, background-color 0.2s",
    margin: "0 8px",
    padding: "4px",
    borderRadius: "50%",
  };

  const selectedStyle = {
    backgroundColor: "#1976d2",
    color: "#fff",
    transform: "scale(1.2)",
  };

  return (
    <>
    <ThemeProvider theme={theme}>
      <div>
        <Grid container spacing={2} columns={16}>
          <Grid size={14}>
            {isEmpty(componentPermissions) ||
              componentPermissions ?.canCreate ? (
                <CategoryDialog
                  categoryId={0}
                  selectedCategoryName={""}
                  callCategories={getCategories}
                  componentPermissions={componentPermissions}
                  actionType={"Add"}
                  isEdit={false}
                />
              ) : null}
          </Grid>

          <Box
            sx={{
              display: "flex",
              alignItems: "center",
              border: "1px solid #ddd",
              borderRadius: "8px",
              padding: "8px",
              width: "fit-content",
              margin: "auto",
            }}
          >
            <Tooltip title="List View" arrow>
              <IconButton
                onClick={() => setViewListMode(true)}
                style={{
                  ...iconButtonStyle,
                  ...(viewListMode ? selectedStyle : {}),
                }}
              >
                <ListIcon fontSize="small" />
              </IconButton>
            </Tooltip>
            <Tooltip title="Grid View" arrow>
              <IconButton
                onClick={() => setViewListMode(false)}
                style={{
                  ...iconButtonStyle,
                  ...(!viewListMode ? selectedStyle : {}),
                }}
              >
                <GridViewIcon fontSize="small" />
              </IconButton>
            </Tooltip>
          </Box>
        </Grid>
      </div>
    </ThemeProvider>
    <div>
      {viewListMode === true ? (
        <Container fluid sx={{ padingLeft: "2px" }}>
          {/* <AssetItemDialog assetItemData={categoryData} callAssetItems={categoryData}/> */}
          {/* Add New Article Button */}

          <Box sx={{ width: "100%" }}>
            <Paper sx={{ width: "100%", mb: 2 }}>
              <TableContainer component={Paper}>
                <AppTableView
                  rows={categories}
                  cols={SOLUTIONS_CATEGORY_COLUMNS({
                    getCategories,
                    componentPermissions,
                    actionType:
                    isEmpty(componentPermissions) ||
                      componentPermissions ?.["canUpdate"]
                        ? "Edit"
                        : "",                     
                  })}
                  initialPageSize={15}
                />
              </TableContainer>
            </Paper>
          </Box>
        </Container>
      ) : (
          <div>
            <ThemeProvider theme={theme}>
              {/* Search Box */}
              <TextField
                label="Search Categories"
                variant="outlined"
                fullWidth
                value={searchTerm}
                onChange={handleSearch}
                style={{ marginBottom: 20, width: "99%" }}
              />
            </ThemeProvider>

            {/* Article List */}
            <Grid container spacing={3}>
              {currentCategories.map((category) => (
                <Grid item xs={12} sm={6} md={4} key={category.id}>
                  <div style={{ padding: 20, border: "1px solid #ddd" }}>
                    {/* <h2>{category.name}</h2> */}
                    <h2>
                      <CategoryDialog
                        categoryId={category.id}
                        selectedCategoryName={category.name}
                        callCategories={getCategories}
                        componentPermissions={componentPermissions}
                        actionType="Edit"
                        isEdit={true}
                      />
                    </h2>
                    <p>{category.description}</p>
                  </div>
                </Grid>
              ))}
            </Grid>

            <Pagination
              count={totalPages}
              page={page}
              onChange={handlePageChange}
              style={{
                marginTop: 20,
                display: "flex",
                justifyContent: "center",
              }}
            />

            {/* Dialog for Adding Article */}
          </div>
        )}
    </div>
    </>
  );
};

export default Category;
